import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const InventoryStatus = () => {
  const inventoryData = [
    { categoria: 'Laptops', stock: 45, minimo: 20, estado: 'normal' },
    { categoria: 'Monitores', stock: 12, minimo: 15, estado: 'bajo' },
    { categoria: 'Teclados', stock: 78, minimo: 30, estado: 'normal' },
    { categoria: 'Ratones', stock: 5, minimo: 25, estado: 'critico' },
    { categoria: 'Cables', stock: 156, minimo: 50, estado: 'normal' },
    { categoria: 'Adaptadores', stock: 23, minimo: 20, estado: 'normal' }
  ];

  const getStatusColor = (estado) => {
    switch (estado) {
      case 'critico':
        return 'var(--color-error)';
      case 'bajo':
        return 'var(--color-warning)';
      case 'normal':
      default:
        return 'var(--color-success)';
    }
  };

  const getStatusIcon = (estado) => {
    switch (estado) {
      case 'critico':
        return { name: 'AlertCircle', color: 'text-error' };
      case 'bajo':
        return { name: 'AlertTriangle', color: 'text-warning' };
      case 'normal':
      default:
        return { name: 'CheckCircle', color: 'text-success' };
    }
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="bg-surface border border-border rounded-lg p-3 shadow-modal">
          <p className="text-sm font-body-medium text-text-primary mb-2">{label}</p>
          <p className="text-sm text-text-secondary">
            Stock actual: <span className="font-body-medium">{data.stock} unidades</span>
          </p>
          <p className="text-sm text-text-secondary">
            Stock mínimo: <span className="font-body-medium">{data.minimo} unidades</span>
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-heading-semibold text-text-primary">
          Estado del Inventario
        </h2>
        <button 
          onClick={() => window.location.href = '/inventory-control'}
          className="text-sm text-primary hover:text-primary-700 font-body-medium transition-micro"
        >
          Ver inventario completo
        </button>
      </div>

      {/* Chart */}
      <div className="w-full h-64 mb-6" aria-label="Gráfico de estado del inventario">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={inventoryData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="categoria" 
              stroke="var(--color-text-muted)"
              fontSize={12}
              angle={-45}
              textAnchor="end"
              height={80}
            />
            <YAxis 
              stroke="var(--color-text-muted)"
              fontSize={12}
            />
            <Tooltip content={<CustomTooltip />} />
            <Bar 
              dataKey="stock" 
              fill={(entry) => getStatusColor(entry.estado)}
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Status List */}
      <div className="space-y-3">
        <h3 className="text-sm font-body-medium text-text-primary mb-3">
          Alertas de Stock
        </h3>
        {inventoryData
          .filter(item => item.estado !== 'normal')
          .map((item, index) => {
            const statusIcon = getStatusIcon(item.estado);
            return (
              <div key={index} className="flex items-center justify-between p-3 rounded-lg bg-secondary-50">
                <div className="flex items-center space-x-3">
                  <Icon name={statusIcon.name} size={16} className={statusIcon.color} />
                  <div>
                    <p className="text-sm font-body-medium text-text-primary">
                      {item.categoria}
                    </p>
                    <p className="text-xs text-text-secondary">
                      {item.stock} unidades disponibles
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-xs text-text-muted">
                    Mín: {item.minimo}
                  </p>
                  <span className={`text-xs font-body-medium ${
                    item.estado === 'critico' ? 'text-error' : 'text-warning'
                  }`}>
                    {item.estado === 'critico' ? 'Stock crítico' : 'Stock bajo'}
                  </span>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default InventoryStatus;